<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>eServices Cluster 💻</h1>
        <h4>The eServices Cluster is responsible for managing the organization’s internal and external IM-related initiatives which involve systems and multimedia applications development.</h4>

        <!-- POSITIONS -->
        <h3>Positions:</h3>


        <!-- POSITION -->
        <h2><b>eServices Developer Training Pool</b></h2>

        <!-- <h4>The AVP for IT Products and Services manages all external engagements of the cluster and ensures the completion of service contracts to clients of the organization. </h4> -->

        <h4>Responsibilities:</h4>
        <ul>
            <li>Helps the AVP's in all post-project and client-related documents</li>
            <li>Trains as an apprentice under the AVP's</li>
            <li>Can be assigned to project teams for the cluster’s initiatives and projects</li>
        </ul>

    </div>
</template>

<script>
export default {
    name: 'PrimerEservs'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>


